<template>
<div class="form-value-with-unit row">
  <div class="col-sm-8">
    <b-form-input v-model="form[field].value" type="number" step="0.01" lang="nb" min="0" @input="cb" />
  </div>
  <div class="col-sm-4">
    <b-form-select v-model="form[field].unit" :options="unitOptions" class="form-control" />
  </div>
</div>
</template>

<script>


export default {

  name: 'form-value-with-unit',
  props: ['form', 'field', 'type', 'input'],
  computed: {
    unitOptions() {
      if (this.type == 'weight') {
        return ['unidades', 'g', 'Kg', 'Ton']
      } else if (this.type == 'size') {
        return ['cm', 'm']
      } else {
        return ['Dias', 'Meses', 'Anos']
      }
    }
  },
  methods: {
    cb() {
      if (this.input) {
        this.input()
      }
    }
  }
};
</script>
